import styled from 'styled-components';

export default styled.div`
  color: ${({ color }) => color};
`;

export const PriceAmount = styled.span`
  font-size: 1.125rem;
  font-weight: 600;
`;

export const PriceText = styled.span``;
